import {Component, OnDestroy, OnInit} from '@angular/core';
import {PractitionerService} from "../shared/services/practitioner.service";
import {ViewStateService} from "../../shared/services/view-state.service";
import {IPurchaseHistory} from "../shared/models/purchaseHistory";
import {UserService} from "../../shared/services/user.service";
import {Router} from "@angular/router";
import { PurchaseService } from 'app/purchase/shared/services/purchase.service';
import { Subject } from "rxjs";
import { debounceTime, takeUntil } from "rxjs/operators";

@Component({
  selector: 'app-purchase-history',
  templateUrl: './purchase-history.component.html',
  styleUrls: ["./purchase-history.scss"],
})
export class PurchaseHistoryComponent implements OnInit, OnDestroy {
  purchaseHistory: IPurchaseHistory[] = [];
  trimmedHistory: IPurchaseHistory[]=[];
  private personId: string;
  monthsHistory = 12;
  ccpInfo: any;
  onDestroy$ = new Subject();

  constructor(private userService: UserService, private viewState: ViewStateService, 
    private purchaseService: PurchaseService,
    private practitionerService: PractitionerService, 
    private router: Router) {
    this.personId = this.userService.CurrentUser.personId;
  }

  ngOnInit() {
    this.viewState.startLoading();
    this.ccpInfo="";
    this.retrievePurchaseHistory();
    this.getCCPInfo();
  }

  updateHistory() {
    this.retrievePurchaseHistory();    
  }

  getCCPInfo() {
    let y;
    this.purchaseService.getCCPInfo(this.personId)
    .pipe(takeUntil(this.onDestroy$))
    .subscribe(res => {
      this.ccpInfo = res;
    },        
    (error) => {
      this.viewState.stopLoading();
    });      
  }

  retrievePurchaseHistory() {
    this.practitionerService.getPurchaseHistory(this.personId, this.monthsHistory)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(res => {                
          this.purchaseHistory = res.sort((d1,d2) => new Date(d1.serviceTransactionDate) < new Date(d2.serviceTransactionDate) ? 1 : -1);
          this.viewState.stopLoading();
        },        
        (error) => {
          this.viewState.stopLoading();
          this.router.navigate(['**']);
        });
  }

  ngOnDestroy() {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
  
}

